export enum MESSAGE_TYPE {
  TEXT = 1,
  IMAGE = 2,
  FILE = 3,
  STICKER = 4,
  SYSTEM = 5,
  COMMENT = 6,
  AI_ACTION = 7,
  ERROR = 8
}
